export var saveForLaterFailure = function saveForLaterFailure(challengeTitle, t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to move "{{challengeTitle}}" to Later', {
      challengeTitle: challengeTitle
    }),
    duration: 'medium'
  };
};
export var saveForLaterSuccess = function saveForLaterSuccess(challengeTitle, t) {
  return {
    severity: 'success',
    message: t('"{{challengeTitle}}" has been moved to Later', {
      challengeTitle: challengeTitle
    }),
    duration: 'medium'
  };
};